export const API_LIST_APP_VERSION = "API_LIST_APP_VERSION"
